import { render, staticRenderFns } from "./TyreJobPage.vue?vue&type=template&id=1026ff04"
import script from "./TyreJobPage.vue?vue&type=script&lang=js"
export * from "./TyreJobPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports